module.exports = __webpack_public_path__ + "static/img/24.d73e0ef1.png";